// removed by extract-text-webpack-plugin
module.exports = {"wasabi-panel":"wasabi-panel","panel-heading":"panel-heading","panel-buttons":"panel-buttons","panel-icon":"panel-icon","panel-body":"panel-body"};


//////////////////
// WEBPACK FOOTER
// ./~/wasabiD/Sass/Layout/Panel.scss
// module id = 247
// module chunks = 0